<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">
    <div class="box" *ngIf="!isLoading">
      <div class="box-header ">
        <h3 class="box-title">
          Select one of qrcode to edit
        </h3>
        <div class="form-group">
          <label>Review:</label>
          <select [(ngModel)]="size" name="size" class="form-control">
            <option (click)="initData()" value="big">2x2(2 small - 2 big)</option>
            <option (click)="initData()" value="small">1x4(4 small)</option>
          </select>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div class="wrap-items">
            <div *ngIf="printData.length !== 0">
              <div *ngIf="size=='big'" class="layout-print page-size">
                <div style="display: inline-block">
                  <div class="item item-sm" [class.selected]="printData[0].selected" (click)="initData('item-sm'); printData[0].selected = !printData[0].selected">
                    <div class="qrcode-img">
                      <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="printData[0].serialId + '-' + printData[0].noId + '-' + printData[0].hmac"></ngx-qrcode>
                    </div>
                    <div class="info info-sm">
                      <span class="product-id"> {{printData[0].productId}} </span>
                      <br>
                      <span class="description"> {{ printData[0].description }} </span>
                      <br>
                      <b>SN</b>: {{printData[0].serialId}}
                      <br>
                      <b>NO</b>: {{printData[0].noId}}
                    </div>
                  </div>
                  <div class="item item-sm" [class.selected]="printData[1].selected" (click)="initData('item-sm'); printData[1].selected = !printData[1].selected">
                    <div class="qrcode-img">
                      <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="printData[1].serialId + '-' + printData[1].noId + '-' + printData[1].hmac"></ngx-qrcode>
                    </div>
                    <div class="info info-sm">
                      <span class="product-id"> {{printData[1].productId}} </span>
                      <br>
                      <span class="description"> {{ printData[1].description }} </span>
                      <br>
                      <b>SN</b>: {{printData[1].serialId}}
                      <br>
                      <b>NO</b>: {{printData[1].noId}}
                    </div>
                  </div>
                </div>
                <div style="display: inline-block">
                  <div class="item item-lg" [class.selected]="printData[2].selected" (click)="initData('item-lg'); printData[2].selected = !printData[2].selected">
                    <div class="qrcode-img">
                      <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-lg-{{this.configCss['qrcode-lg'].value[0]*10}}" [qrc-value]="printData[2].serialId + '-' + printData[2].noId + '-' + printData[2].hmac"></ngx-qrcode>
                    </div>
                    <div class="info info-lg">
                      <span class="product-id"> {{printData[2].productId}} </span>
                      <br>
                      <span class="description"> {{ printData[2].description }} </span>
                    </div>
                    <div class="sub-info-lg">
                      <b>SN</b>: {{printData[2].serialId}}
                      <br>
                      <b>NO</b>: {{printData[2].noId}}
                    </div>
                  </div>
                  <div class="item item-lg" [class.selected]="printData[3].selected" (click)="initData('item-lg'); printData[3].selected = !printData[3].selected">
                    <div class="qrcode-img">
                      <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-lg-{{this.configCss['qrcode-lg'].value[0]*10}}" [qrc-value]="printData[3].serialId + '-' + printData[3].noId + '-' + printData[3].hmac"></ngx-qrcode>
                    </div>
                    <div class="info info-lg">
                      <span class="product-id"> {{printData[3].productId}} </span>
                      <br>
                      <span class="description"> {{ printData[3].description }} </span>
                    </div>
                    <div class="sub-info-lg">
                      <b>SN</b>: {{printData[3].serialId}}
                      <br>
                      <b>NO</b>: {{printData[3].noId}}
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="size=='small'" class="layout-print1 page-size">
                <div class="item1 item-sm" [class.selected]="printData[0].selected" (click)="initData('item-sm'); printData[0].selected = !printData[0].selected">
                  <div class="qrcode-img">
                    <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="printData[0].serialId + '-' + printData[0].noId + '-' + printData[0].hmac"></ngx-qrcode>
                  </div>
                  <div class="info info-sm">
                    <span class="product-id"> {{printData[0].productId}} </span>
                    <br>
                    <span class="description"> {{ printData[0].description }} </span>
                    <br>
                    <b>SN</b>: {{printData[0].serialId}}
                    <br>
                    <b>NO</b>: {{printData[0].noId}}
                  </div>
                </div>
                <div class="item1 item-sm" [class.selected]="printData[0].selected" (click)="initData('item-sm'); printData[0].selected = !printData[0].selected">
                  <div class="qrcode-img">
                    <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="printData[1].serialId + '-' + printData[1].noId + '-' + printData[1].hmac"></ngx-qrcode>
                  </div>
                  <div class="info info-sm">
                    <span class="product-id"> {{printData[1].productId}} </span>
                    <br>
                    <span class="description"> {{ printData[1].description }} </span>
                    <br>
                    <b>SN</b>: {{printData[1].serialId}}
                    <br>
                    <b>NO</b>: {{printData[1].noId}}
                  </div>
                </div>
                <div class="item1 item-sm" [class.selected]="printData[0].selected" (click)="initData('item-sm'); printData[0].selected = !printData[0].selected">
                  <div class="qrcode-img">
                    <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="printData[1].serialId + '-' + printData[1].noId + '-' + printData[1].hmac"></ngx-qrcode>
                  </div>
                  <div class="info info-sm">
                    <span class="product-id"> {{printData[1].productId}} </span>
                    <br>
                    <span class="description"> {{ printData[1].description }} </span>
                    <br>
                    <b>SN</b>: {{printData[1].serialId}}
                    <br>
                    <b>NO</b>: {{printData[1].noId}}
                  </div>
                </div>
                <div class="item1 item-sm" [class.selected]="printData[0].selected" (click)="initData('item-sm'); printData[0].selected = !printData[0].selected">
                  <div class="qrcode-img">
                    <ngx-qrcode [qrc-element-type]="'img'" qrc-class="qrcode-sm-{{this.configCss['qrcode-sm'].value[0]*10}}" [qrc-value]="printData[1].serialId + '-' + printData[1].noId + '-' + printData[1].hmac"></ngx-qrcode>
                  </div>
                  <div class="info info-sm">
                    <span class="product-id"> {{printData[1].productId}} </span>
                    <br>
                    <span class="description"> {{ printData[1].description }} </span>
                    <br>
                    <b>SN</b>: {{printData[1].serialId}}
                    <br>
                    <b>NO</b>: {{printData[1].noId}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedQrCode.name != undefined" class="col-sm-12 col-md-6">
          <div class="">
            <label>Name LayoutPrint</label>
            <input class="form-inline" ngModel [(ngModel)]="nameLayout">
            <a class="btn btn-danger" routerLink="/layout-print">Close</a>
            <button [disabled]="nameLayout === ''" class="btn btn-success" (click)="saveLayoutPrint()">Save</button>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-2">
              <b>Size QrCode</b>
              <div class="form-inline">
                <select ngModel [(ngModel)]="configCss[selectedQrCode.class == '.item-lg' ? 'qrcode-lg':'qrcode-sm'].value[0]" class="form-control">
                  <option *ngFor="let size of sizeQrcode" [value]="size">{{size}}</option>
                </select>
                {{configCss[selectedQrCode.class == '.item-lg' ? 'qrcode-lg':'qrcode-sm'].unit}}
              </div>
            </div>
            <div class="col-sm-12 col-md-5">
              <b>{{selectedQrCode.name}}</b>
              <div class="form-inline">
                WIDTH:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('width', configCss[selectedQrCode.class]['width'].value[0])"
                  (keyup)="renderCss('width', configCss[selectedQrCode.class]['width'].value[0])" ngModel [(ngModel)]="configCss[selectedQrCode.class]['width'].value[0]"
                  class="form-control"> {{configCss[selectedQrCode.class]['width'].unit}}
              </div>
              <div class="form-inline">
                HEIGHT:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('height'+selectedQrCode.class, configCss[selectedQrCode.class]['height'].value[0])"
                  (keyup)="renderCss('height'+selectedQrCode.class, configCss[selectedQrCode.class]['height'].value[0])" ngModel
                  [(ngModel)]="configCss[selectedQrCode.class]['height'].value[0]" class="form-control"> {{configCss[selectedQrCode.class]['height'].unit}}
              </div>
              <div class="form-inline">
                PADDING TOP:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('padding-top', configCss[selectedQrCode.class]['padding'].value[0])"
                  (keyup)="renderCss('padding-top', configCss[selectedQrCode.class]['padding'].value[0])" ngModel [(ngModel)]="configCss[selectedQrCode.class]['padding'].value[0]"
                  class="form-control"> {{configCss[selectedQrCode.class]['padding'].unit}}
              </div>
              <div class="form-inline">
                PADDING RIGHT:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('padding-right', configCss[selectedQrCode.class]['padding'].value[1])"
                  (keyup)="renderCss('padding-right', configCss[selectedQrCode.class]['padding'].value[1])" ngModel [(ngModel)]="configCss[selectedQrCode.class]['padding'].value[1]"
                  class="form-control"> {{configCss[selectedQrCode.class]['padding'].unit}}
              </div>
              <div class="form-inline">
                PADDING BOTTOM:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('padding-bottom', configCss[selectedQrCode.class]['padding'].value[2])"
                  (keyup)="renderCss('padding-bottom', configCss[selectedQrCode.class]['padding'].value[2])" ngModel [(ngModel)]="configCss[selectedQrCode.class]['padding'].value[2]"
                  class="form-control"> {{configCss[selectedQrCode.class]['padding'].unit}}
              </div>
              <div class="form-inline">
                PADDING LEFT:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('padding-left', configCss[selectedQrCode.class]['padding'].value[3])"
                  (keyup)="renderCss('padding-left', configCss[selectedQrCode.class]['padding'].value[3])" ngModel [(ngModel)]="configCss[selectedQrCode.class]['padding'].value[3]"
                  class="form-control"> {{configCss[selectedQrCode.class]['padding'].unit}}
              </div>

            </div>
            <div class="col-sm-12 col-md-5">
              <b>TEXT INFO</b>
              <div class="form-inline">
                FONT SIZE:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('font-size'+selectedQrCode.classInfo, configCss[selectedQrCode.classInfo]['font-size'].value[0])"
                  (keyup)="renderCss('font-size'+selectedQrCode.classInfo, configCss[selectedQrCode.classInfo]['font-size'].value[0])"
                  ngModel [(ngModel)]="configCss[selectedQrCode.classInfo]['font-size'].value[0]" class="form-control"> {{configCss[selectedQrCode.classInfo]['font-size'].unit}}
              </div>
              <div class="form-inline">
                LINE SPACING:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('line-height'+selectedQrCode.classInfo, configCss[selectedQrCode.classInfo]['line-height'].value[0])"
                  (keyup)="renderCss('line-height'+selectedQrCode.classInfo, configCss[selectedQrCode.classInfo]['line-height'].value[0])"
                  ngModel [(ngModel)]="configCss[selectedQrCode.classInfo]['line-height'].value[0]" class="form-control"> {{configCss[selectedQrCode.classInfo]['line-height'].unit}}
              </div>
            </div>
            <div *ngIf="selectedQrCode.class === '.item-lg'" class="col-sm-12 col-md-3">
              <b>TEXT SUB INFO</b>
              <div class="form-inline">
                FONT SIZE:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('font-size.sub-info-lg', configCss['.sub-info-lg']['font-size'].value[0])"
                  (keyup)="renderCss('font-size.sub-info-lg', configCss['.sub-info-lg']['font-size'].value[0])" ngModel [(ngModel)]="configCss['.sub-info-lg']['font-size'].value[0]"
                  class="form-control"> {{configCss['.sub-info-lg']['font-size'].unit}}
              </div>
              <div class="form-inline">
                LINE SPACING:
                <input type="number" style="width: 70px" step="0.1" (change)="renderCss('line-height.sub-info-lg', configCss['.sub-info-lg']['line-height'].value[0])"
                  (keyup)="renderCss('line-height.sub-info-lg', configCss['.sub-info-lg']['line-height'].value[0])" ngModel
                  [(ngModel)]="configCss['.sub-info-lg']['line-height'].value[0]" class="form-control"> {{configCss['.sub-info-lg']['line-height'].unit}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</div>
<div [innerHTML]="style"></div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print-form/layout-print-form.component.html